import { connector } from "../../utils/common/connector";

const controller = "campaign";

// ---------------------------------------------
// CREATE CAMPAIGN
// ---------------------------------------------
export const createCampaignService = async (params) => {
  let reply;

  try {
    const response = await connector.post(controller, "createCampaign", params);

    reply = {
      campaign: response ?? {},
    };
  } catch (error) {
    console.log(error);

    reply = {
      campaign: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CAMPAIGNS
// ---------------------------------------------
export const getCampaignsService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "getcampaigns", params);

    reply = {
      campaigns: response?.campaigns ?? [],
      totalCampaigns: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);

    reply = {
      campaigns: [],
      totalCampaigns: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CAMPAIGN BY ID
// ---------------------------------------------
export const getCampaignByIdService = async (params) => {
  let reply;

  try {
    const response = await connector.get(controller, "byId", params);

    reply = {
      campaign: response ?? {},
    };
  } catch (error) {
    console.log(error);

    reply = {
      campaign: {},
    };
  }

  return reply;
};
